import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/issueBulkManualInvoices', request)
}

export {post}
